import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store.ts';

interface UdfUpdateState {
	leasedUdfUploadInProgress: boolean;
	assetGridRefreshTrigger: number;
}

const initialState: UdfUpdateState = {
	leasedUdfUploadInProgress: false,
	assetGridRefreshTrigger: 0,
};

const udfUpdateSlice = createSlice({
	name: 'udfUpdate',
	initialState,
	reducers: {
		acknowledged(state) {
			state.leasedUdfUploadInProgress = false;
		},
		setUploadInProgress(state) {
			state.leasedUdfUploadInProgress = true;
		},
		bumpAssetGridRefresh(state) {
			state.assetGridRefreshTrigger += 1;
		}
	},
});

export const { acknowledged, setUploadInProgress, bumpAssetGridRefresh } = udfUpdateSlice.actions;
export default udfUpdateSlice.reducer;

export const selectLeasedUdfInProgress = (state: RootState) => state.udfUpdateSlice?.leasedUdfUploadInProgress ?? false;
export const selectAssetGridRefreshTrigger = (state: RootState) => state.udfUpdateSlice?.assetGridRefreshTrigger ?? 0;
